export default {
    'add-training': 'إضافة تدريب',
    'delete-message-trainings': 'هل أنت متأكد من أنك تريد حذف هذا التدريب؟'
}